var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "stepper-template",
    { attrs: { nbStep: _vm.nbStep, currentStepNumber: _vm.currentStepNumber } },
    [
      _c("template", { slot: "header" }, [
        _c(
          "header",
          { staticClass: "step-header-container flex-level" },
          [
            _c(
              "div",
              { staticClass: "dinlineb valign-middle ml-3" },
              [
                _c(
                  "icon-svg",
                  {
                    staticClass: "m-0 mb-2 secondary-blue",
                    attrs: {
                      "icon-name": "sellsy",
                      width: 118,
                      height: 28,
                      viewBox: "0 0 118 28"
                    }
                  },
                  [_c("icon-sellsy-text")],
                  1
                ),
                _vm._v(" "),
                _vm.previousStep
                  ? _c(
                      "router-link",
                      {
                        staticClass: "grey-link semibold flex-level",
                        attrs: {
                          to: {
                            name: _vm.previousStep,
                            query: { lang: _vm.$route.query.lang }
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon-arrow-back mr-1" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$l10n.__("Page précédente")))
                        ])
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "grey-link semibold flex-level",
                        attrs: { href: "https://go.sellsy.com" }
                      },
                      [
                        _c("i", { staticClass: "icon-arrow-back mr-1" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Retourner sur go.sellsy.com"))
                          )
                        ])
                      ]
                    )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "fade" } },
              [
                _vm.currentStepNumber === 1
                  ? _c("lang-selector", {
                      staticClass: "flex-item-right",
                      attrs: {
                        value: _vm.countrySelected,
                        availableLanguages: ["en", "fr"]
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }